import { getAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import * as mocks from "./Map.mock";
import { IUserLocation } from "./Map.model";
import axios from "axios";

export function getBoundingBox(
  userLocation: IUserLocation,
  meta: any,
  callback: Function,
  callbackError: Function,
  mock: string,
  removeLoading:boolean
) {
  if (mock === "true") {
    const mockData = mocks.getTmbCards.data.stopLocationOrCoordLocation;
    try {
      sessionStorage.setItem("raas-trip-mock-data", JSON.stringify(mockData));
    } catch (error) {
      sessionStorage.setItem("raas-trip-mock-data", "error saving mock");
    }
    callback(mockData);
  } else {
    const apiWithParams = `/location-boundingbox?llLat=${userLocation.llLat}&urLat=${userLocation.urLat}&llLon=${userLocation.llLon}&urLon=${userLocation.urLon}&meta=${meta}`;
    getAxios(apiNames.PLAN, false, apiWithParams,removeLoading)
      .then((data: any) => {
        callback(data.data.stopLocationOrCoordLocation);
      })
      .catch((error: any) => {
        callbackError(error);
      });
  }
}

export async function getBoundingBoxByLatitudeLongitude(
  latitude: number,
  longitude: number,
  callback: Function,
  errorCallback: Function
) {
  try {
    const response = await axios.get(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
    );
    const data = response.data;
    callback(data.boundingbox);
  } catch (error) {
    errorCallback(error);
  }
}

export function getRouteApi(
  originCoordLat: number,
  originCoordLong: number,
  destCoordLat: number,
  destCoordLong: number,
  callback: Function,
  callbackError: Function
) {
  const apiWithParams = `/route-coords?originCoordLat=${originCoordLat}&originCoordLong=${originCoordLong}&destCoordLat=${destCoordLat}&destCoordLong=${destCoordLong}`;
  getAxios(apiNames.PLAN, false, apiWithParams)
    .then((data: any) => {
      const duration=data.data.duration.value
      const routeCoordinates = data.data.gisRoute.map((point:any) => [point.lat, point.lon]);
      callback({routeCoordinates,duration});
    })
    .catch((error: any) => {
      callbackError(error);
    });
}
